import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yjjy7kddvy: FaireBrandEntity = {
  token: "b_yjjy7kddvy",
  type: "brand",
  name: "Rustic Pours",
  avatarUrl:
    "https://cdn.faire.com/fastly/286df8e7787e7619310ea6f8162d566c11060b45911791009e01747c6f9df3b8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/51a86fe40354b58a9f61a001b5070261adb54e48d80c0067bca6a941e243851e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/286df8e7787e7619310ea6f8162d566c11060b45911791009e01747c6f9df3b8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/51a86fe40354b58a9f61a001b5070261adb54e48d80c0067bca6a941e243851e.png",
  location: "Philomath, OR, USA",
  minimumOrderDollars: 139,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "At Rustic Pours, we believe a beverage can be more than just a drink- it can be an experience. Born in Oregon, our artisan lemonades are thoughtfully crafted with high-quality ingredients, timeless flavors, and a touch of artistry. Every batch is crafted with care, blending flavor and design in collaboration with artists who share our vision of intentional, elevated living. From our carefully chosen ingredients to our thoughtfully designed packaging, Rustic Pours is about bringing approachable familiar flavors  and elevating them to quiet luxurious moments. Our lemonades aren't just for sipping, they are made to complement gatherings, cafes, curated spaces, and shared experiences. Every pour tells a story of craftsmanship, connection, and hospitality, inviting you to savor not just the drink, but the moment. Delight fully with Rustic Pours- a sip of joy, thoughtfully crafted for every occasion. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:05.926Z",
    importedBy: "entity-db-cli",
  },
};
